import React, { useCallback, useRef, useState } from 'react';
import { type ProductStatusType } from '@/common/types/product-status.type';
import { Skeleton } from 'antd';
import classNames from 'classnames';
import CustomImage from '@/common/components/custom-image/custom-image.component';
import DiagonalLine from '@/common/components/diagonal-line';
import Tag from '@/common/components/tag/tag.component';
import { perisanProductStatusConstant } from '@/common/constants/perisan-product-status.constant';

interface DisplayProps {
  productStatus?: ProductStatusType;
  productName?: string;
  thumbnailImage: string | null;
  availability: string;
  discount?: number;
}

function ProductDisplay({
  availability,
  thumbnailImage,
  discount,
  productName,
}: DisplayProps) {
  const notInStock = availability === 'OutOfStock';
  const shouldDisplayTag = availability === 'InStock' && discount;
  const [error, setError] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleError = useCallback(
    (event: React.SyntheticEvent<HTMLImageElement>) => {
      setError(true);
    },
    []
  );

  return (
    <div ref={containerRef} className={classNames('mx-auto mb-2  w-full')}>
      <div className="relative h-fit w-full overflow-hidden rounded-xl border-[0.5px] border-silver-400">
        {notInStock ? <DiagonalLine /> : null}
        {!error && thumbnailImage && (
          <CustomImage
            alt={productName || 'تصویر محصول'}
            src={thumbnailImage}
            className={classNames(
              'inset-0  !aspect-square w-full rounded-xl !object-cover !object-center',
              {
                'opacity-50': notInStock,
              }
            )}
            width={100}
            height={100}
            onError={handleError}
          />
        )}
        {error && (
          <div className="!aspect-square w-full">
            <Skeleton.Image
              active
              className={`image-skeleton mx-auto !h-full !w-full rounded-2xl`}
            />
          </div>
        )}

        <div className="">
          {notInStock && availability.length ? (
            <Tag className="ltr absolute bottom-2 right-0 z-40 flex flex-col">
              {
                perisanProductStatusConstant[
                  availability.toLocaleUpperCase() as keyof typeof perisanProductStatusConstant
                ]
              }
            </Tag>
          ) : null}
          {shouldDisplayTag ? (
            <Tag className="ltr absolute bottom-2 right-0 z-40 flex flex-col">
              {discount}%
            </Tag>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default ProductDisplay;
